import { buildUrl } from "helpers";
import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ProductBoxListItem } from "../../product.types";
import { ApiRoutesProducts } from "./../../constants/enums";

export const requestGetProductBoxesList = async (
  params: GetListRequestParams,
  productVariantId?: string
): Promise<GetListResponse<ProductBoxListItem>> => {
  return await instance.get(
    buildUrl(ApiRoutesProducts.ProductBoxes, productVariantId ?? ""),
    { params }
  );
};
